import {
  Checkbox,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material"
import type { AppNode } from "@features/builder/graph/types"
import type { MaybeConnection } from "@features/builder/CreateEdges/types"

type CreateEdgesPreviewProps = {
  maybeConnections: MaybeConnection[]
  setMaybeConnections: (value: MaybeConnection[]) => void
}

export default function CreateEdgesPreview({
  maybeConnections,
  setMaybeConnections,
}: CreateEdgesPreviewProps) {
  const handleSelect = (index: number) => {
    const updatedConnections = maybeConnections.map((connection, connectionIndex) =>
      connectionIndex === index
        ? { ...connection, isSelected: !connection.isSelected }
        : connection,
    )

    setMaybeConnections(updatedConnections)
  }

  const getNodeLabel = (node: AppNode) => node.data.label ?? node.id

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">Select</TableCell>
                <TableCell>Parent</TableCell>
                <TableCell>Child</TableCell>
                <TableCell>Errors</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {maybeConnections.map(({ parent, child, errors, isSelected }, index) => (
                <TableRow
                  sx={{ backgroundColor: errors.length > 0 ? "error.light" : "transparent" }}
                  key={`${parent.id}_${child.id}`}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={isSelected}
                      disabled={errors.length > 0}
                      onChange={() => handleSelect(index)}
                    />
                  </TableCell>
                  <TableCell>{getNodeLabel(parent)}</TableCell>
                  <TableCell>{getNodeLabel(child)}</TableCell>
                  <TableCell sx={{ whiteSpace: "pre-line" }}>{errors.join(",\n")}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  )
}
